import classNames from "classnames";
import React from "react";
import {IconSource} from "../../../../shared/enums/iconSource";
import Icon from "../icon/icon";
import "./spinner.sass";

export interface ISpinnerProps {
  source?: IconSource;
  large?: boolean;
}

const Spinner: React.FunctionComponent<ISpinnerProps> = ({
  source = IconSource.loading,
  large = true
}) => {
  return (
    <div className={classNames("spinner", {large})}>
      <Icon source={source} />
    </div>
  );
};

export default Spinner;
